import React from "react";
import PopUp from "Components/PopUp/PopUp";
import { Button } from "Components/ui/button";
import { useNavigate } from "react-router-dom";

function ChallengeClosePopup({ open, setOpen, data }) {
  const navigate = useNavigate();
  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title={`Deactivation Notice`}
      width={"600px"}
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-4 py-4 items-center justify-center">
          <div className="flex flex-col gap-1">
            <div className="font-N_Bold text-[20px] flex items-center gap-2">
              Challenge Failed
              <span className="font-N_Roman text-[13px] text-primary">
                Challenge ID: CH#ID {`${data?.login}`}
              </span>
            </div>
            <div className="text-[15px] font-N_Roman opacity-[0.44]">
              {data?.reason}
            </div>
          </div>
        </div>
        <Button className=" w-[150px] h-[40px]" onClick={() => navigate(`/`)}>
          Continue
        </Button>
      </div>
    </PopUp>
  );
}

export default ChallengeClosePopup;
